import { render } from "./InstallWizardElectronicInstall.vue?vue&type=template&id=2840a0f3"
import script from "./InstallWizardElectronicInstall.vue?vue&type=script&lang=js"
export * from "./InstallWizardElectronicInstall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__